import React from 'react';
import { AdminPanelHero, AdminPanelSection } from './AdminPanelUi';

export default function AdminAdvancedPanel({ rawJson, onValidate, onCopy, onDownload }) {
  return (
    <div className="admin-advanced admin-panel-workspace-root">
      <AdminPanelHero
        title="Advanced"
        lead="Backup or inspect the full catalog. Day-to-day editing uses Categories and Products."
      />

      <AdminPanelSection
        title="Catalog JSON"
        subtitle="Download, validate, or copy the full catalog export."
        action={
          <div className="d-flex flex-wrap gap-2">
            <button type="button" className="btn btn-outline-success btn-sm" onClick={onDownload}>
              Download
            </button>
            <button type="button" className="btn btn-outline-primary btn-sm" onClick={onValidate}>
              Validate
            </button>
            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onCopy}>
              Copy
            </button>
          </div>
        }
      >
        <textarea
          className="form-control admin-advanced-json"
          rows={14}
          value={rawJson}
          readOnly
          spellCheck={false}
          aria-label="Catalog JSON"
        />
      </AdminPanelSection>
    </div>
  );
}
